import * as React from "react"
import {Box} from "@mui/material"
import {AmchartSeeker,ModalSeeker} from "@ui-seeker/core"

import SellerDeepDiveOffersEvolutionChartToolbar from "./Toolbar";
import useSellerDeepDiveOffersEvolutionData from "./@hooks/useSearch";
import { sellerDeepDiveChartActualPrice } from "../@signals";


export default function SellerDeepShareMblEvolutionChart() {

    const {
        dataEvolution, dataEvolutionKeys, isLoadingDataEvolution, chartColors,
        evolutionLabel, dateRange, onChange, resetEvolutionData
    } = useSellerDeepDiveOffersEvolutionData()
    const price_key = sellerDeepDiveChartActualPrice.value ? 'chart' : 'chartList'

	if (!dataEvolution[price_key]?.length || isLoadingDataEvolution) return <></>

    return <ModalSeeker 
        hideActions 
        isOpen={!!dataEvolution[price_key]?.length}
        title={`Offers Comparison Evolution - ${evolutionLabel}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            rootID={'OffersEvolutionChart'}
            data={dataEvolution[price_key]}
            title={<Box id="evolution-chart"> </Box>}
            pdfProps={{
                titlePDF:`Offers Comparison Evolution - ${evolutionLabel}`
            }}
            series={dataEvolutionKeys.map(key => ({
                name: key, yField: key,
                xField: "date",
                stacked: true,
                connect: true,
                color: chartColors[key],
                fills: {
                    fillOpacity: 0.5,
                    visible:true
                }
            }))}
            chartProps={{
                numberFormat: `#,###.00  %`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                }
            }}
            cardProps={{ actions: <SellerDeepDiveOffersEvolutionChartToolbar dateRange={dateRange} onChange={onChange} /> }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}